import { z } from 'zod'
import {
  NameSchema,
  ReviewRoundNumberSchema,
  ReviewStatusSchema,
} from '../property.models.ts'
import { PostProductionReviewKeySchema } from '../review.models.ts'
import { RoundStatusSchema } from '../round.models.ts'
import { ReviewIdSchema, RoundIdSchema } from '../unique-id.models.ts'
import { ActivityTypeAndDataSchema } from './utilities.ts'

export const PostProductionReviewStatusChangedActivityDetailsSchema =
  ActivityTypeAndDataSchema(
    'post_production_review_status_changed',
    z.object({
      reviewId: ReviewIdSchema,
      reviewKey: PostProductionReviewKeySchema,
      displayName: NameSchema,
      reviewStatus: ReviewStatusSchema,
      roundId: RoundIdSchema,
      roundNumber: ReviewRoundNumberSchema,
      roundStatus: RoundStatusSchema,
    })
  )
